import React from 'react';

import './dropDownItem.css';

const DropDownItem = ({
  isSelected = false,
  showBoldText = false,
  btnText = '',
  LeftComponent = null,
  RightComponent = null,
  onClick = () => {},
}) => {
  return (
    <div
      className={`et-v2-drop-down-item-container ${
        isSelected ? 'et-v2-drop-down-item-selected' : ''
      }`}
      onClick={onClick}>
      {LeftComponent && (
        <div className="et-v2-drop-down-item-left-comp">{LeftComponent}</div>
      )}
      <div
        className={`et-v2-drop-down-item-txt ${showBoldText ? 'et-v2-drop-down-item-bold-txt' : ''}`}>
        {btnText}
      </div>
      {RightComponent && (
        <div className="et-v2-drop-down-item-right-comp">{RightComponent}</div>
      )}
    </div>
  );
};

export default DropDownItem;
